import { _getFromLocalStorage } from "../Utils/helpers";
const nigeriaStates = _getFromLocalStorage("cityAndStatesData").states;

export const nigeria_states = nigeriaStates;

export const lagos_lgas = [
	{
		name: "Select Lga",
		text: "Select Lga",
		value: "",
	},
	{
		text: "Agege",
		value: "Agege",
		isdefault: 0,
		name: "Agege",
	},
	{
		text: "Ajeromi Ifelodun",
		value: "Ajeromi Ifelodun",
		isdefault: 0,
		name: "Ajeromi Ifelodun",
	},
	{
		text: "Alimosho",
		value: "Alimosho",
		isdefault: 0,
		name: "Alimosho",
	},
	{
		text: "Amuwo Odofin",
		value: "Amuwo Odofin",
		isdefault: 0,
		name: "Amuwo Odofin",
	},
	{
		text: "Apapa",
		value: "Apapa",
		isdefault: 0,
		name: "Apapa",
	},
	{
		text: "Badagry",
		value: "Badagry",
		isdefault: 0,
		name: "Badagry",
	},
	{
		text: "Epe",
		value: "Epe",
		isdefault: 0,
		name: "Epe",
	},
	{
		text: "Eti Osa",
		value: "Eti Osa",
		isdefault: 0,
		name: "Eti Osa",
	},
	{
		text: "Ibeju Lekki",
		value: "Ibeju Lekki",
		isdefault: 0,
		name: "Ibeju Lekki",
	},
	{
		text: "Ifako Ijaiye",
		value: "Ifako Ijaiye",
		isdefault: 0,
		name: "Ifako Ijaiye",
	},
	{
		text: "Ikeja",
		value: "Ikeja",
		isdefault: 0,
		name: "Ikeja",
	},
	{
		text: "Ikorodu",
		value: "Ikorodu",
		isdefault: 0,
		name: "Ikorodu",
	},
	{
		text: "Kosofe",
		value: "Kosofe",
		isdefault: 0,
		name: "Kosofe",
	},
	{
		text: "Lagos Island",
		value: "Lagos Island",
		isdefault: 0,
		name: "Lagos Island",
	},
	{
		text: "Lagos Mainland",
		value: "Lagos Mainland",
		isdefault: 0,
		name: "Lagos Mainland",
	},
	{
		text: "Mushin",
		value: "Mushin",
		isdefault: 0,
		name: "Mushin",
	},
	{
		text: "Ojo",
		value: "Ojo",
		isdefault: 0,
		name: "Ojo",
	},
	{
		text: "Oshodi Isolo",
		value: "Oshodi Isolo",
		isdefault: 0,
		name: "Oshodi Isolo",
	},
	{
		text: "Shomolu",
		value: "Shomolu",
		isdefault: 0,
		name: "Shomolu",
	},
	{
		text: "Surulere",
		value: "Surulere",
		isdefault: 0,
		name: "Surulere",
	},
	{
		text: "Egbeda",
		value: "Egbeda",
		isdefault: 0,
		name: "Egbeda",
	},
	{
		text: "Ifako-Ijaiye",
		value: "Ifako-Ijaiye",
		isdefault: 0,
		name: "Ifako-Ijaiye",
	},
	{
		name: "Others",
		value: "others",
	},
];

const bankNames = [
	{
		name: "Select bank name",
		value: "",
	},
	{
		id: "1",
		name: "Access Bank",
		value: "Access Bank",
	},
	{
		id: "2",
		name: "Citibank",
		value: "Citibank",
	},
	{
		id: "3",
		name: "Diamond Bank",
		value: "Diamond Bank",
	},
	{
		id: "4",
		name: "Dynamic Standard Bank",
		value: "Dynamic Standard Bank",
	},
	{
		id: "5",
		name: "Ecobank Nigeria",
		value: "Ecobank Nigeria",
	},
	{
		id: "6",
		name: "Fidelity Bank Nigeria",
		value: "Fidelity Bank Nigeria",
	},
	{
		id: "7",
		name: "First Bank of Nigeria",
		value: "First Bank of Nigeria",
	},
	{
		id: "8",
		name: "First City Monument Bank",
		value: "First City Monument Bank",
	},
	{
		id: "9",
		name: "Guaranty Trust Bank",
		value: "Guaranty Trust Bank",
	},
	{
		id: "10",
		name: "Heritage Bank Plc",
		value: "Heritage Bank Plc",
	},
	{
		id: "11",
		name: "Jaiz Bank",
		value: "Jaiz Bank",
	},
	{
		id: "12",
		name: "Keystone Bank Limited",
		value: "Keystone Bank Limited",
	},
	{
		id: "13",
		name: "Providus Bank Plc",
		value: "Providus Bank Plc",
	},
	{
		id: "14",
		name: "Polaris Bank",
		value: "Polaris Bank",
	},
	{
		id: "15",
		name: "Stanbic IBTC Bank Nigeria Limited",
		value: "Stanbic IBTC Bank Nigeria Limited",
	},
	{
		id: "16",
		name: "Standard Chartered Bank",
		value: "Standard Chartered Bank",
	},
	{
		id: "17",
		name: "Sterling Bank",
		value: "Sterling Bank",
	},
	{
		id: "18",
		name: "Suntrust Bank Nigeria Limited",
		value: "Suntrust Bank Nigeria Limited",
	},
	{
		id: "19",
		name: "Union Bank of Nigeria",
		value: "Union Bank of Nigeria",
	},
	{
		id: "20",
		name: "United Bank for Africa",
		value: "United Bank for Africa",
	},
	{
		id: "21",
		name: "Unity Bank Plc",
		value: "Unity Bank Plc",
	},
	{
		id: "22",
		name: "Wema Bank",
		value: "Wema Bank",
	},
	{
		id: "23",
		name: "Zenith Bank",
		value: "Zenith Bank",
	},
];

export const bank_names = bankNames;

export const nigeria_lgas = _getFromLocalStorage("cityAndStatesData").city;
